import { preferences, setPreferences, usePreference } from './preferences.js';

/** The floating Jabberr is a pet each person chooses to show; it is hidden unless they turn it on. Stored with the
 *  person's preferences on the server, so the choice follows them to every device. */
export function petVisible(): boolean {
  return preferences().petVisible === true;
}

export function setPetVisible(visible: boolean): void {
  setPreferences({ petVisible: visible });
}

export function usePetVisible(): boolean {
  return usePreference('petVisible') === true;
}
